<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            :isShowEditButton="false"
            @removeService="removeService"
        >
            <template #content>
                <div class="border-green-gray py-2 px-2.5 md:py-3.5 md:px-5 mb-3.5">
                    <div class="text-gray-900 text-base xs:text-lg">
                        主契約及所有壽險附約辦理繳清，且同時取消其他附約。
                    </div>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
export default {
    name: 'C1Data',
    components: {
        CollapseConfirmData,
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('C1');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, removeService };
    },
};
</script>
